import { Component, Input } from "@angular/core";
import { Capability } from "../../../models";

@Component({
    selector: "brain-feature",
    templateUrl: "./feature.component.html",
    styleUrls: ["./feature.component.scss"]
})
export class FeatureComponent {

  @Input()
  capability: Capability;

}
